
        import '/home/builduser/work/575538235ca6a4de/santa-editor/packages/hiddenElements/components/hiddenPanelOpenButton/hiddenPanelOpenButton.scss.css.virtualfile';
        module.exports = {"button":"_button_1cnib_1","buttonWithPimple":"_buttonWithPimple_1cnib_9"};